import api from './BaseApi';
import { getSpecialMenu } from './SpecialApi';
import { getRegularMenuDay } from './RegularApi';

export function getRecipe({ id, ...rest }) {
  return api.get(`recipe/${id}`, rest);
}

export function setCookingFor(payload) {
  return api.post('cooking_for/update', payload);
}

export function isRecipeAccessDenied(error) {
  return error?.response?.status === 403 && !!error.response.data?.error?.access_required;
}

export function canRetryRecipeRead(error) {
  const status = error?.response?.status;
  return !error?.response || status >= 500 || status === 408 || status === 429;
}

export async function getRecipePreview({ id, menu, date, special }) {
  if (!menu) return null;
  const response = special
    ? await getSpecialMenu(menu)
    : await getRegularMenuDay(date ? new Date(date) : new Date(), menu);
  if (!response.data?.success) {
    const error = new Error('PreviewUnavailable');
    error.response = response;
    throw error;
  }
  const data = response.data.data;
  const cards = special
    ? (data.recipe_set?.recipes || []).flatMap(group => group.recipes || [])
    : (data.menu?.meals || []).flatMap(day => (day.meals || []).map(meal => meal.recipe));
  const recipe = cards.find(card => card && card.id === id);
  // A direct URL is still a preview of the selected collection, not permission
  // to load an unrelated recipe or expose full fields from a paid response.
  return recipe ? { id: recipe.id, title: recipe.title, cover_url: recipe.cover_url } : null;
}
